import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import {auth} from '@/fb';
import {store} from './store/store'
import InstantSearch from 'vue-instantsearch';
import 'core-js/stable';
import Editor from 'vue-editor-js';


Vue.use(InstantSearch);
Vue.use(Editor);

Vue.config.productionTip = false

let app = null;



//wait for firebase auth to init before creating the app
auth.onAuthStateChanged(()=>{
  //init app if not created
  if(!app){
    app = new Vue({
      store:store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
